"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Raven = _interopRequireDefault(require("Raven"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedCurrency = _interopRequireDefault(require("I18n/components/FormattedCurrency"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _UILockedFeature = _interopRequireDefault(require("ui-addon-upgrades/decorators/UILockedFeature"));

var _UILock = _interopRequireDefault(require("ui-addon-upgrades/icons/UILock"));

var _FloatingAlertStore = _interopRequireDefault(require("UIComponents/alert/FloatingAlertStore"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _UITooltip = _interopRequireDefault(require("UIComponents/tooltip/UITooltip"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _GoodSubTypes = _interopRequireDefault(require("../constants/GoodSubTypes"));

var _StripePurchaseErrors = _interopRequireDefault(require("../constants/StripePurchaseErrors"));

var _ProductMarketplaceClient = _interopRequireDefault(require("../data/ProductMarketplaceClient"));

var _env = require("../utils/env");

var _utils = require("../utils/utils");

var _constants = require("../lib/usage/constants");

var _HubspotUrls = _interopRequireDefault(require("../constants/HubspotUrls"));

var getI18nKey = function getI18nKey(path) {
  return "MarketplaceUI.goodDetailsPage.purchaseButton." + path;
};

var _default = _react.default.createClass({
  displayName: "PurchaseButton",
  propTypes: {
    goodNameUrlToken: _propTypes.default.string.isRequired,
    hasContentAccess: _propTypes.default.bool.isRequired,
    hasInstallAccess: _propTypes.default.bool.isRequired,
    hasEmailAccess: _propTypes.default.bool.isRequired,
    hasEmailFreeOrStarter: _propTypes.default.bool.isRequired,
    isCustomer: _propTypes.default.bool.isRequired,
    isGoodProvider: _propTypes.default.bool.isRequired,
    isEmailGood: _propTypes.default.bool.isRequired,
    isFree: _propTypes.default.bool.isRequired,
    isPurchased: _propTypes.default.bool.isRequired,
    isTrial: _propTypes.default.bool.isRequired,
    newVersionAvailable: _propTypes.default.bool.isRequired,
    goodId: _propTypes.default.number.isRequired,
    goodName: _propTypes.default.string.isRequired,
    goodSubType: _propTypes.default.string.isRequired,
    payWithStripe: _propTypes.default.bool.isRequired,
    portalName: _propTypes.default.string,
    previewMode: _propTypes.default.bool.isRequired,
    price: _propTypes.default.number.isRequired,
    providerUrlToken: _propTypes.default.string.isRequired,
    purchaseGoodWithPaypal: _propTypes.default.func.isRequired,
    purchaseGoodWithStripe: _propTypes.default.func.isRequired,
    reinstallGood: _propTypes.default.func.isRequired,
    trackPurchasedGood: _propTypes.default.func.isRequired,
    triggerPurchaseErrorModalOpening: _propTypes.default.func.isRequired
  },
  calculatePurchasePriceCents: function calculatePurchasePriceCents(purchasePriceDollars) {
    return purchasePriceDollars * 100;
  },
  getRequestDataCommonToStripeAndPaypal: function getRequestDataCommonToStripeAndPaypal() {
    return {
      goodId: this.props.goodId,
      price: this.props.price,
      purchaseThruCreatePage: false
    };
  },
  getStripePublishableKey: function getStripePublishableKey() {
    if ((0, _env.isProd)()) {
      return 'pk_live_T0AlYwoUk5DCTeoQa3F5cSWs';
    }

    return 'pk_test_kLD9iKqWosWefMxPIXAU6rw1';
  },
  handlePurchaseButtonClick: function handlePurchaseButtonClick() {
    var _this$props = this.props,
        goodId = _this$props.goodId,
        goodName = _this$props.goodName,
        goodNameUrlToken = _this$props.goodNameUrlToken,
        goodSubType = _this$props.goodSubType,
        hasEmailFreeOrStarter = _this$props.hasEmailFreeOrStarter,
        isCustomer = _this$props.isCustomer,
        isEmailGood = _this$props.isEmailGood,
        isFree = _this$props.isFree,
        newVersionAvailable = _this$props.newVersionAvailable,
        payWithStripe = _this$props.payWithStripe,
        providerUrlToken = _this$props.providerUrlToken,
        purchaseGoodWithPaypal = _this$props.purchaseGoodWithPaypal,
        purchaseGoodWithStripe = _this$props.purchaseGoodWithStripe,
        reinstallGood = _this$props.reinstallGood;

    if (isEmailGood && hasEmailFreeOrStarter) {
      return;
    }

    if (newVersionAvailable) {
      reinstallGood(goodId, goodName, true);
    } else if (!isCustomer) {
      window.location = (0, _utils.getRedirectToDetails)(providerUrlToken, goodNameUrlToken);
    } else if (isFree) {
      var data = this.getRequestDataCommonToStripeAndPaypal();
      this.trackPurchase(goodSubType, 0, 'free');
      purchaseGoodWithStripe(data);
    } else if (payWithStripe) {
      this.handleStripePurchase();
    } else {
      var _data = this.getRequestDataCommonToStripeAndPaypal();

      purchaseGoodWithPaypal(_data);
    }
  },
  handleStripePurchase: function handleStripePurchase() {
    var _this = this;

    var _this$props2 = this.props,
        goodId = _this$props2.goodId,
        triggerPurchaseErrorModalOpening = _this$props2.triggerPurchaseErrorModalOpening;

    if (!window.Stripe) {
      triggerPurchaseErrorModalOpening(_StripePurchaseErrors.default.STRIPE_CHECKOUT_FAILED);
      return;
    }

    _ProductMarketplaceClient.default.getStripeSessionId(goodId).then(function (_ref) {
      var connectedAccountId = _ref.connectedAccountId,
          sessionId = _ref.sessionId;
      var stripe = window.Stripe(_this.getStripePublishableKey(), {
        stripeAccount: connectedAccountId
      });
      return stripe.redirectToCheckout({
        sessionId: sessionId
      }).then(function (result) {
        _FloatingAlertStore.default.addAlert({
          message: result.error.message,
          titleText: getI18nKey('stripeRedirectError.titleText'),
          type: 'danger'
        });
      });
    }).catch(function () {
      triggerPurchaseErrorModalOpening(_StripePurchaseErrors.default.STRIPE_CHECKOUT_FAILED);
    });
  },
  trackPurchase: function trackPurchase(goodSubType, price, paymentType) {
    var isTrial = this.props.isTrial;
    this.props.trackPurchasedGood(_constants.Screens.DETAILS, price, goodSubType, {
      payment_type: paymentType,
      is_trial: isTrial
    });
  },
  renderMessage: function renderMessage() {
    var _this$props3 = this.props,
        goodSubType = _this$props3.goodSubType,
        isPurchased = _this$props3.isPurchased,
        newVersionAvailable = _this$props3.newVersionAvailable,
        price = _this$props3.price;

    if (newVersionAvailable) {
      return _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey('installUpdate')
      });
    }

    var goodSubTypeKey;

    if (goodSubType === _GoodSubTypes.default.PACKS) {
      goodSubTypeKey = 'pack';
    } else if (goodSubType === _GoodSubTypes.default.CUSTOM_MODULE) {
      goodSubTypeKey = 'module';
    } else {
      goodSubTypeKey = 'indivTemplate';
    }

    if (isPurchased) {
      return _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey(goodSubTypeKey + ".installed")
      });
    }

    if (!price) {
      return _react.default.createElement(_FormattedMessage.default, {
        message: getI18nKey(goodSubTypeKey + ".free")
      });
    }

    return _react.default.createElement(_FormattedReactMessage.default, {
      message: getI18nKey(goodSubTypeKey + ".paid"),
      options: {
        price: _react.default.createElement(_FormattedCurrency.default, {
          currencyCode: "USD",
          simplifyCurrency: true,
          value: price
        })
      }
    });
  },
  render: function render() {
    var _this$props4 = this.props,
        goodName = _this$props4.goodName,
        goodNameUrlToken = _this$props4.goodNameUrlToken,
        hasContentAccess = _this$props4.hasContentAccess,
        hasInstallAccess = _this$props4.hasInstallAccess,
        hasEmailAccess = _this$props4.hasEmailAccess,
        hasEmailFreeOrStarter = _this$props4.hasEmailFreeOrStarter,
        isCustomer = _this$props4.isCustomer,
        isGoodProvider = _this$props4.isGoodProvider,
        isEmailGood = _this$props4.isEmailGood,
        isFree = _this$props4.isFree,
        isPurchased = _this$props4.isPurchased,
        newVersionAvailable = _this$props4.newVersionAvailable,
        portalName = _this$props4.portalName,
        previewMode = _this$props4.previewMode,
        price = _this$props4.price,
        providerUrlToken = _this$props4.providerUrlToken;

    if (!isFree && !price || isFree && price) {
      if (!previewMode) {
        _Raven.default.captureMessage("purchase-button error for " + goodName + " with price of " + price);
      }

      return null;
    }

    var isEmailLockedFeature = isEmailGood && !isPurchased && hasEmailFreeOrStarter;
    var isDisabled = !isCustomer || isGoodProvider || previewMode || isPurchased && !newVersionAvailable || isCustomer && !hasInstallAccess || isCustomer && isEmailGood && !hasEmailAccess || isCustomer && !isEmailGood && !hasContentAccess;

    var purchaseButton = _react.default.createElement(_UIButton.default, {
      className: (0, _utils.getPurchaseButtonClassNames)(previewMode),
      disabled: isDisabled,
      onClick: this.handlePurchaseButtonClick,
      use: "primary"
    }, this.renderMessage(), isEmailLockedFeature && _react.default.createElement(_UILock.default, null));

    if (isEmailLockedFeature) {
      return _react.default.createElement(_UITooltip.default, {
        placement: "bottom left",
        title: _react.default.createElement(_FormattedMessage.default, {
          message: getI18nKey('tooltip.freeOrStarterEmail')
        })
      }, _react.default.createElement("div", null, _react.default.createElement(_UILockedFeature.default, {
        modalKey: "marketplace-marketing-professional-email",
        upgradeData: {
          app: 'marketplace',
          screen: 'details',
          upgradeProduct: 'marketing-pro',
          uniqueId: 'purchase-good'
        }
      }, _react.default.cloneElement(purchaseButton, {
        disabled: false
      }))));
    }

    var tooltip;

    if (isGoodProvider) {
      tooltip = _react.default.createElement(_FormattedJSXMessage.default, {
        message: getI18nKey('tooltip.providerPermission_jsx'),
        elements: {
          Link: _UILink.default
        },
        options: {
          anotherAccountLink: (0, _utils.getRedirectToDetails)(providerUrlToken, goodNameUrlToken),
          hubspotFreeLink: _HubspotUrls.default.HUBSPOT_FREE + "?hubs_content=" + window.location.href
        }
      });
    } else if (isCustomer) {
      if (!isPurchased) {
        if (isEmailGood && !hasEmailAccess) {
          tooltip = _react.default.createElement(_FormattedMessage.default, {
            message: getI18nKey('tooltip.emailPermission')
          });
        } else if (!isEmailGood && !hasContentAccess) {
          tooltip = _react.default.createElement(_FormattedMessage.default, {
            message: getI18nKey('tooltip.contentPermission')
          });
        } else if (!hasInstallAccess) {
          tooltip = _react.default.createElement(_FormattedMessage.default, {
            message: getI18nKey('tooltip.marketplacePermission')
          });
        }
      } else if (!isDisabled) {
        tooltip = _react.default.createElement(_FormattedMessage.default, {
          message: getI18nKey('tooltip.portalLicense'),
          options: {
            portalName: portalName
          }
        });
      }
    }

    return _react.default.createElement(_UITooltip.default, {
      disabled: !tooltip,
      placement: "bottom left",
      title: tooltip
    }, purchaseButton);
  }
});

exports.default = _default;
module.exports = exports.default;